
import { useParams } from "react-router-dom"; // Import useParams
import PlantationViewLayer from "../components/PlantationViewLayer";
import MasterLayout from "../masterLayout/MasterLayout";

const PlantationPageView = () => {
    const { id } = useParams(); // Get the id from the URL parameters
  
  return (
     <>
     {/* MasterLayout */}
      <MasterLayout>
        <PlantationViewLayer  id={id} />
 
    </MasterLayout>
    </>
  );
};

export default PlantationPageView;
